import {
    NEWSPAPER_PERMIT,
    NEWSPAPER_CLASSIFICATIONS,
    PARTICULARS_OF_NEWSPAPER,
    PARTICULARS_OF_PRINTER,
    PARTICULARS_OF_PUBLISHER,
    ADDITIONAL_PARTICULARS_OF_APPLICANT,
    PARTICULARS_OF_CHIEF_EDITOR,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/NPPLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import { findCountryByCode, haveLocalOrForeignContactNumber } from 'utils/utils';

export const formatNPP = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    const countryCode =
        licenceDetails?.particularsOfPublisher?.registeredAddress?.country ?? licenceDetails?.particularsOfPublisher?.address?.country;

    licence = {
        id: 'newspaper-permit',
        formID: 'newspaper-permit',
        hasError: true,
        title: application?.startsWith('IMDA-IRIS-Work-LICApplication') ? 'Application Details' : 'Licence Details',
        values: {
            [`${NEWSPAPER_PERMIT}-please-specifiy-the-type-of-permit-to-apply`]:
                licenceDetails?.newspaperPermit?.pleaseSpecifyTheTypeOfPermitToApply ?? '-',
            [`${NEWSPAPER_PERMIT}-mode-of-print`]: licenceDetails?.newspaperPermit?.modeOfPrint ?? '-',
            [`${NEWSPAPER_PERMIT}-location-of-print`]: licenceDetails?.newspaperPermit?.locationOfPrint ?? '-',
            [`${NEWSPAPER_PERMIT}-printing-press-licence-no`]: licenceDetails?.newspaperPermit?.printingPressLicenceNo ?? '-',

            [`${NEWSPAPER_CLASSIFICATIONS}-objectives`]: licenceDetails?.newspaperClassifications?.objectives ?? '-',
            [`${NEWSPAPER_CLASSIFICATIONS}-target-readers`]: licenceDetails?.newspaperClassifications?.targetReaders ?? '-',
            [`${NEWSPAPER_CLASSIFICATIONS}-contents`]: licenceDetails?.newspaperClassifications?.contents ?? '-',
            [`${NEWSPAPER_CLASSIFICATIONS}-regular-features`]: licenceDetails?.newspaperClassifications?.regularFeatures ?? '-',
            [`${NEWSPAPER_CLASSIFICATIONS}-genre-code`]: licenceDetails?.newspaperClassifications?.genreCode ?? '-',
            [`${NEWSPAPER_CLASSIFICATIONS}-genre-description`]: licenceDetails?.newspaperClassifications?.genreDescription ?? '-',

            [`${PARTICULARS_OF_NEWSPAPER}-name-of-newspaper-in-english`]:
                licenceDetails?.particularsOfNewspaper?.nameOfNewspaperInEnglish ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-languages`]: licenceDetails?.particularsOfNewspaper?.languageS
                .filter((entry: any) => !/other/i.test(entry.mixedValue))
                .map((entry: any) => entry.mixedValue)
                .join(', '),
            [`${PARTICULARS_OF_NEWSPAPER}-other-languages`]: licenceDetails?.particularsOfNewspaper?.otherLanguageS ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-frequency`]: licenceDetails?.particularsOfNewspaper?.Frequency ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-frequency-description-1`]: licenceDetails?.particularsOfNewspaper?.frequencyDescription1 ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-frequency-description-2`]: licenceDetails?.particularsOfNewspaper?.frequencyDescription2 ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-reason-for-exemption`]: licenceDetails?.particularsOfNewspaper?.reasonForExemption ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-free-copy`]: licenceDetails?.particularsOfNewspaper?.freeCopy ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-selling-price`]: licenceDetails?.particularsOfNewspaper?.ifNoSellingPrice
                ? parseFloat(licenceDetails.particularsOfNewspaper.ifNoSellingPrice).toFixed(2)
                : '-',
            [`${PARTICULARS_OF_NEWSPAPER}-total-no-of-copies-printed-per-issue`]:
                licenceDetails?.particularsOfNewspaper?.totalNoOfCopiesPrintedPerIssue ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-no-of-copies-to-be-circulated-in-singapore-printed-per-issue`]:
                licenceDetails?.particularsOfNewspaper?.noOfCopiesToBeCirculatedInSingapore ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-advertisements`]: licenceDetails?.particularsOfNewspaper?.advertisements ?? '-',
            [`${PARTICULARS_OF_NEWSPAPER}-online-link`]:
                licenceDetails?.particularsOfNewspaper?.ifThisNewspapersIsAvailableOnlineStateTheUrlHttp ?? '-',

            [`${PARTICULARS_OF_PRINTER}-type-of-printer`]: licenceDetails?.particularsOfPrinter?.typeOfPrinter ?? '-',
            [`${PARTICULARS_OF_PRINTER}-name-of-printing-press`]: licenceDetails?.particularsOfPrinter?.nameOfPrintingPress ?? '-',
            [`${PARTICULARS_OF_PRINTER}-name-of-printing-press-foreign`]:
                licenceDetails?.particularsOfPrinter?.nameOfPrintingPressForeign ?? '-',
            [`${PARTICULARS_OF_PRINTER}-printing-press-licence-no`]: licenceDetails?.newspaperPermit?.printingPressLicenceNo ?? '-',
            [`${PARTICULARS_OF_PRINTER}-company-id`]: licenceDetails?.particularsOfPrinter?.CompanyID ?? '-',
            [`${PARTICULARS_OF_PRINTER}-address-line-one`]: licenceDetails?.particularsOfPrinter?.address?.AddressLine1 ?? '-',
            [`${PARTICULARS_OF_PRINTER}-address-line-two`]: licenceDetails?.particularsOfPrinter?.address?.AddressLine2 ?? '-',
            [`${PARTICULARS_OF_PRINTER}-address-line-three`]: licenceDetails?.particularsOfPrinter?.address?.addressLine3 ?? '-',
            [`${PARTICULARS_OF_PRINTER}-country`]: findCountryByCode(licenceDetails?.particularsOfPrinter?.address?.country),
            [`${PARTICULARS_OF_PRINTER}-address-type`]: licenceDetails?.particularsOfPrinter?.address?.addressType ?? '-',
            [`${PARTICULARS_OF_PRINTER}-tel-no`]: licenceDetails?.particularsOfPrinter?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${PARTICULARS_OF_PRINTER}-mobile-no`]: licenceDetails?.particularsOfPrinter?.contactPersonParticulars?.mobileNumber ?? '-',
            [`${PARTICULARS_OF_PRINTER}-email`]: licenceDetails?.particularsOfPrinter?.contactPersonParticulars?.email ?? '-',

            [`${PARTICULARS_OF_PRINTER}-postal-code`]: licenceDetails?.particularsOfPrinter?.address?.postalCode ?? '-',
            [`${PARTICULARS_OF_PRINTER}-block-house-no`]: licenceDetails?.particularsOfPrinter?.address?.blockNo ?? '-',
            [`${PARTICULARS_OF_PRINTER}-street-name`]: licenceDetails?.particularsOfPrinter?.address?.streetName ?? '-',
            [`${PARTICULARS_OF_PRINTER}-floor-level-optional`]: licenceDetails?.particularsOfPrinter?.address?.floor ?? '-',
            [`${PARTICULARS_OF_PRINTER}-unit-optional`]: licenceDetails?.particularsOfPrinter?.address?.unit ?? '-',
            [`${PARTICULARS_OF_PRINTER}-building-name`]: licenceDetails?.particularsOfPrinter?.address?.buildingName ?? '-',

            [`${PARTICULARS_OF_PUBLISHER}-type-of-publisher`]: licenceDetails?.particularsOfPublisher?.typeOfPublisher ?? '-',
            [`${PARTICULARS_OF_PUBLISHER}-name-of-publisher-company-name`]:
                licenceDetails?.particularsOfPublisher?.nameOfPublisher ?? licenceDetails?.particularsOfPublisher?.CompanyNameJSON ?? '-',
            [`${PARTICULARS_OF_PUBLISHER}-address-line-one`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.AddressLine1 ??
                licenceDetails?.particularsOfPublisher?.address?.AddressLine1 ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-address-line-two`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.AddressLine2 ??
                licenceDetails?.particularsOfPublisher?.address?.AddressLine2 ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-address-line-three`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.addressLine3 ??
                licenceDetails?.particularsOfPublisher?.address?.addressLine3 ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-country`]: findCountryByCode(countryCode),
            [`${PARTICULARS_OF_PUBLISHER}-address-type`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.addressType ??
                licenceDetails?.particularsOfPublisher?.address?.addressType ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-postal-code`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.postalCode ??
                licenceDetails?.particularsOfPublisher?.address?.postalCode ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-block-house-no`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.blockNo ??
                licenceDetails?.particularsOfPublisher?.address?.blockNo ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-street-name`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.streetName ??
                licenceDetails?.particularsOfPublisher?.address?.streetName ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-floor-level-optional`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.floor ??
                licenceDetails?.particularsOfPublisher?.address?.floor ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-unit-optional`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.unit ??
                licenceDetails?.particularsOfPublisher?.address?.unit ??
                '-',
            [`${PARTICULARS_OF_PUBLISHER}-building-name`]:
                licenceDetails?.particularsOfPublisher?.registeredAddress?.buildingName ??
                licenceDetails?.particularsOfPublisher?.address?.buildingName ??
                '-',

            [`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`]: haveLocalOrForeignContactNumber(
                licenceDetails?.particularsOfPublisherOfficeContact?.doYouHaveLocalOrForeignContactNumber
            ),
            [`${PARTICULARS_OF_PUBLISHER}-tel-no`]: licenceDetails?.particularsOfPublisherOfficeContact?.telNo ?? '-',
            [`${PARTICULARS_OF_PUBLISHER}-mobile-no`]: licenceDetails?.particularsOfPublisherOfficeContact?.mobileNo ?? '-',
            [`${PARTICULARS_OF_PUBLISHER}-overseas-tel-no`]: licenceDetails?.particularsOfPublisherOfficeContact?.overseasTelNo ?? '-',
            [`${PARTICULARS_OF_PUBLISHER}-overseas-mobile-no`]:
                licenceDetails?.particularsOfPublisherOfficeContact?.overseasMobileNo ?? '-',
            [`${PARTICULARS_OF_PUBLISHER}-email`]: licenceDetails?.particularsOfPublisherOfficeContact?.email ?? '-',

            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-designation`]:
                licenceDetails?.additionalParticularsOfApplicantChiefEditorProprietor?.designation ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-is-the-applicants-company-same-as-the-publisher`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietor?.isTheApplicantSCompanySameAsThePublisher ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-name-of-registered-office-company-employer`]:
                licenceDetails?.particularsOfAppChiefEditorProprietorDtlsOfRegOfCompEmp?.nameOfRegisteredOfficeCompanyEmployer ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-uen-registration-number`]:
                licenceDetails?.particularsOfAppChiefEditorProprietorDtlsOfRegOfCompEmp?.uenRegistrationNumber ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-uen-registration-number-type`]:
                licenceDetails?.particularsOfAppChiefEditorProprietorDtlsOfRegOfCompEmp?.uenRegistrationNumberType ?? '-',

            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.addressType ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-line-one`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.address?.AddressLine1 ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-line-two`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.address?.AddressLine2 ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-line-three`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.address?.addressLine3 ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-country`]: findCountryByCode(
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.address?.country
            ),
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-postal-code`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.localAddress?.postalCode ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-block-house-no`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.localAddress?.blockNo ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-street-name`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.localAddress?.streetName ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-floor-level-optional`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.localAddress?.floor ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-unit-optional`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.localAddress?.unit ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-building-name`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeAddress?.localAddress?.buildingName ?? '-',

            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`]: haveLocalOrForeignContactNumber(
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeContact?.doYouHaveLocalOrForeignContactNumber
            ),
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-tel-no`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeContact?.officeTelNumber ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-mobile-no`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeContact?.mobileNumber ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-overseas-tel-no`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeContact?.overseasOfficeTelNumber ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-overseas-mobile-no`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeContact?.overseasMobileNumber ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-email`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorOfficeContact?.email ?? '-',
            [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-is-the-chief-editor-same-as-applicant`]:
                licenceDetails?.particularsOfApplicantChiefEditorProprietorResidentialAddress?.isTheChiefEditorSameAsApplicant ?? '-',

            [`${PARTICULARS_OF_CHIEF_EDITOR}-salutation-title`]: licenceDetails?.particularsOfChiefEditor?.salutationTitle ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-names-as-per-official-document`]:
                licenceDetails?.particularsOfChiefEditor?.namesAsPerOfficialDocument ?? '-',
            // [`${PARTICULARS_OF_CHIEF_EDITOR}-passport-number`]: licenceDetails?.particularsOfChiefEditor?.passportNo ?? '-',
            // [`${PARTICULARS_OF_CHIEF_EDITOR}-date-of-birth`]: licenceDetails?.particularsOfChiefEditor?.dateOfBirth ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-designation`]: licenceDetails?.particularsOfChiefEditor?.designation ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-is-the-chief-editors-company-same-as-publisher`]:
                licenceDetails?.particularsOfChiefEditor?.isTheChiefEditorSCompanySameAsPublisher ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-name-of-registered-office-company-employer`]:
                licenceDetails?.particularsOfChiefEditorDetailsOfRegisteredOfficeCompEmp?.nameOfRegisteredOfficeCompanyEmployer ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-uen-registration-number`]:
                licenceDetails?.particularsOfChiefEditorDetailsOfRegisteredOfficeCompEmp?.uenRegistrationNumber ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-uen-registration-number-type`]:
                licenceDetails?.particularsOfChiefEditorDetailsOfRegisteredOfficeCompEmp?.uenRegistrationNumberType ?? '-',

            // chief editor office address
            [`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`]: licenceDetails?.particularsOfChiefEditorOfficeAddress?.addressType ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-address-line-one`]:
                licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.AddressLine1 ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-address-line-two`]:
                licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.AddressLine2 ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-address-line-three`]:
                licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.addressLine3 ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-country`]: findCountryByCode(
                licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.country
            ),
            [`${PARTICULARS_OF_CHIEF_EDITOR}-postal-code`]:
                (licenceDetails?.particularsOfChiefEditorOfficeAddress?.localAddress?.postalCode ||
                    licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.postalCode) ??
                '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-block-house-no`]:
                (licenceDetails?.particularsOfChiefEditorOfficeAddress?.localAddress?.blockNo ||
                    licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.blockNo) ??
                '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-street-name`]:
                (licenceDetails?.particularsOfChiefEditorOfficeAddress?.localAddress?.streetName ||
                    licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.streetName) ??
                '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-floor-level-optional`]:
                (licenceDetails?.particularsOfChiefEditorOfficeAddress?.localAddress?.floor ||
                    licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.floor) ??
                '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-unit-optional`]:
                (licenceDetails?.particularsOfChiefEditorOfficeAddress?.localAddress?.unit ||
                    licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.unit) ??
                '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-building-name`]:
                (licenceDetails?.particularsOfChiefEditorOfficeAddress?.localAddress?.buildingName ||
                    licenceDetails?.particularsOfChiefEditorOfficeAddress?.address?.buildingName) ??
                '-',

            [`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`]: haveLocalOrForeignContactNumber(
                licenceDetails?.particularsOfChiefEditorOfficeContact?.doYouHaveLocalOrForeignContactNumber
            ),
            [`${PARTICULARS_OF_CHIEF_EDITOR}-tel-no`]: licenceDetails?.particularsOfChiefEditorOfficeContact?.officeTelNo ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-mobile-no`]: licenceDetails?.particularsOfChiefEditorOfficeContact?.mobileNo ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-overseas-tel-no`]:
                licenceDetails?.particularsOfChiefEditorOfficeContact?.overseasOfficeTelNo ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-overseas-mobile-no`]:
                licenceDetails?.particularsOfChiefEditorOfficeContact?.overseasMobileNo ?? '-',
            [`${PARTICULARS_OF_CHIEF_EDITOR}-email`]: licenceDetails?.particularsOfChiefEditorOfficeContact?.email ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const nppPayload = {
    formatNPP
};

export default nppPayload;
